import { ModalSize, ModalOverlayStyle } from '@interfaces/common.interface';

export class ModalConfig<D = any> {
  data?: D;
  size?: ModalSize = ModalSize.DEFAULT;
  style?: ModalOverlayStyle = 'default';
  closeButton?: boolean = true;
}
